// @flow
import urlCatalog from '@angi/url-catalog';
import onePlatformRedirectService from '../../common/onePlatformRedirectService';

const leadsHomePagePath = (id: number | string): string => `/app/h/${id}/home`;

/**
 * Resolves where a business-list selection should navigate.
 * Leads pros in the 1P cohort get the gateway redirect URL; otherwise the existing office route.
 * Ads pros never call the gateway.
 */
const resolveSelectedProDestination = (
  id: number | string,
  proType: ?string,
): Promise<string> => {
  if ((proType || '').toLowerCase() !== 'leads') {
    return Promise.resolve(`/app/home/${id}`);
  }

  return onePlatformRedirectService
    .getOnePlatformRedirect(String(id), leadsHomePagePath(id))
    .then(redirectUrl => redirectUrl || urlCatalog.office.leads.homePage(id));
};

export default resolveSelectedProDestination;



// WEBPACK FOOTER //
// ./src/modules/home/common/selectedProDestination.js